import LoyaltyProgramModal from "./LoyaltyProgramModal";
import { closeLoyaltyProgramModal } from "../../redux/slices/loyaltyModalSlice";
import { useDispatch, useSelector } from "react-redux";

// Opened from the account menu, the cart and checkout via openLoyaltyProgramModal.
const LoyaltyProgramModule = () => {
  const dispatch = useDispatch();
  const modalState = useSelector((state) => state.loyaltyModalData);

  return (
    <LoyaltyProgramModal
      closeModal={() => dispatch(closeLoyaltyProgramModal())}
      active={modalState}
    />
  );
};

export default LoyaltyProgramModule;
